const metadataCont = {
  title: 'Cruncher Systems',
  description: 'Cruncher Systems',
  generator: 'Cruncher Systems',
  canonical: '/',
  manifest: '/manifest.json',
  og_title: 'Cruncher Systems',
  og_description: 'Cruncher Systems',
  keywords: 'Cruncher Systems',
  authors: [{ name: 'Cruncher Systems', url: '' }],
  viewport:
    'minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover',
  icons: [
    { rel: 'apple-touch-icon', url: '/logo/cruncher-logo.svg' },
    { rel: 'icon', url: '/cruncher-favicon-1.ico' },
  ],
};

export { metadataCont };
